<template xmlns:el="http://www.w3.org/1999/html">
  <div class="box">
    <el-row>
      <el-col :span="12">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="padding-left:10px;line-height: 46px;">
          <el-breadcrumb-item :to="{ path: '' }">当前位置</el-breadcrumb-item>
          <el-breadcrumb-item>{{name}}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
      <el-col :span="12" style="margin-top:7px;padding-right:10px;text-align: right">
        <slot></slot>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: 'NavPath',
    props: {
      name: {
        type: String,
        required: false
      }
    },
    data () {
      return {
      }
    }
  }
</script>
